export const common = {
  nav: {
    home: 'الرئيسية',
    about: 'من نحن',
    training: 'التدريب',
    give: 'التبرع',
    contact: 'اتصل بنا',
  },
  hero: {
    title: 'تنشئة جيل',
    subtitle: 'تمكين المتعبدين والقادة لتحويل العالم من خلال العبادة الحقيقية وحضور الله',
    watchBtn: 'شاهد',
    joinBtn: 'انضم إلى AID',
  },
  about: {
    badge: 'من نحن',
    title: 'تنشئة المتعبدين والقادة',
    intro: 'عبادة AID تعني "آمين في الظلام". نحن عائلة فنية نختار أن نقول آمين في عالم مظلم، نعبد الرب ونسير بأمانة معه.',
    paragraph1: 'نساعد الجيل القادم على النمو في حضور الله وأن يصبحوا متعبدين وقادة يؤثرون في جيلهم. من خلال التجمعات المتمحورة حول العبادة، نقود الناس إلى لقاءات أعمق مع الله.',
    paragraph2: 'من خلال خدمة الجيل القادم، نساعد الأفراد على اكتشاف هويتهم ومواهبهم ودعوتهم التي منحها الله لهم، ونشجعهم على استخدام إبداعهم وقدراتهم الموسيقية وإمكاناتهم القيادية ومواهبهم الروحية.',
    paragraph3: 'من خلال إنشاء محتوى العبادة - الأغاني والترتيبات والتسجيلات والوسائط - نطور المهارات الموسيقية ونساعدهم على إدارة مواهبهم بهدف والتعبير عن إيمانهم من خلال العبادة.',
    paragraph4: 'من خلال التوجيه والتدريب، نسير بجانبهم حتى ينموا أقوياء في حضور الله، راسخين في كلمته، وواثقين في دعوتهم.',
    learnMoreBtn: 'تعرف على المزيد عن مهمتنا',
  },
  training: {
    badge: 'التدريب',
    title: 'تجهيز المتعبدين والقادة',
    subtitle: 'برنامج تعليمي لتنشئة متعبدين وقادة سيختبرون حضور الله ويحولون الأمم',
    program1Title: 'تدريب قائد العبادة',
    program1Desc: 'تدريب احترافي لتطوير كل من الدعوة والمهارات كقائد عبادة',
    program2Title: 'الأساس الكتابي',
    program2Desc: 'تعلم عميق لجوهر ولاهوت العبادة على أساس كتابي',
    program3Title: 'إنشاء محتوى التسبيح',
    program3Desc: 'إنشاء محتوى العبادة من خلال الموسيقى والإبداع',
    program4Title: 'التكوين الروحي',
    program4Desc: 'رحلة النضج الروحي في علاقة حميمة مع الله',
    comingSoonTitle: 'برنامج التدريب 2026 قريباً',
    comingSoonSubtitle: 'انضم إلينا في رحلة تنشئة متعبدي وقادة الجيل القادم',
    comingSoonBtn: 'قريباً',
  },
  give: {
    badge: 'التبرع',
    title: 'كن جزءاً من رحلتنا',
    subtitle: 'دعمك يساعد في تنشئة الجيل القادم من المتعبدين والقادة الذين سيحولون العالم',
    impactArea1Title: 'خدمة الشباب',
    impactArea1Desc: 'دعم البرامج والفعاليات التي تساعد الشباب على النمو في الإيمان',
    impactArea2Title: 'تدريب القيادة',
    impactArea2Desc: 'تجهيز قادة العبادة من خلال التدريب والإرشاد',
    impactArea3Title: 'خدمة الإرسالية',
    impactArea3Desc: 'نشر رسالة الرجاء والعبادة في جميع أنحاء العالم',
    impactNote: '100% من تبرعك يذهب مباشرة إلى الخدمة',
    impactNoteDesc: 'كل دولار تتبرع به يحدث تأثيراً حقيقياً في حياة الجيل القادم',
    donateBtn: 'تبرع الآن',
    partnerBtn: 'كن شريكاً',
    modalTitle: 'ادعم خدمتنا',
    selectAmount: 'اختر المبلغ',
    customAmount: 'مبلغ مخصص',
    donorName: 'الاسم الكامل',
    donorNamePlaceholder: 'أدخل اسمك',
    donorEmail: 'البريد الإلكتروني',
    donorEmailPlaceholder: 'أدخل بريدك الإلكتروني',
    message: 'رسالة (اختياري)',
    messagePlaceholder: 'شارك سبب دعمك...',
    donateButton: 'تبرع $',
    processing: 'جاري المعالجة...',
    paypalNote: 'ستتم إعادة توجيهك إلى باي بال لإكمال تبرعك بشكل آمن',
    successTitle: 'شكراً لك!',
    successMessage: 'شكراً لدعمك السخي! ستتلقى تأكيداً بالبريد الإلكتروني قريباً.',
  },
  contact: {
    badge: 'اتصل بنا',
    title: 'دعونا نتواصل',
    subtitle: 'لديك أسئلة أو تريد معرفة المزيد؟ نحن هنا للمساعدة',
    namePlaceholder: 'اسمك',
    emailPlaceholder: 'بريدك الإلكتروني',
    messagePlaceholder: 'رسالتك',
    sendBtn: 'إرسال الرسالة',
    sending: 'جاري الإرسال...',
    success: 'تم إرسال رسالتك بنجاح!',
    error: 'فشل إرسال الرسالة. يرجى المحاولة مرة أخرى.',
  },
  footer: {
    description: 'تنشئة متعبدين وقادة لتحويل العالم من خلال العبادة الحقيقية وحضور الله',
    quickLinks: 'روابط سريعة',
    connect: 'تواصل',
    rights: 'جميع الحقوق محفوظة',
  },
};